import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { useAuthStore, useI18nStore, useRouterStore } from "../stores/StoreContext"
import { routes } from "./routes"

export const CallbackPage = observer(() => {
  const authStore = useAuthStore()
  const router = useRouterStore()
  const i18nStore = useI18nStore()

  // Redirect to home after successful authentication
  // The actual callback handling is done in the route's onEnter handler
  useEffect(() => {
    if (authStore.isAuthenticated && !authStore.isLoading) {
      router.goTo(routes.home)
    }
  }, [authStore.isAuthenticated, authStore.isLoading, router.goTo])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        {!authStore.error && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white mx-auto mb-4" />
            <p className="text-lg">{i18nStore.t("authenticating")}</p>
          </>
        )}
        {authStore.error && (
          <>
            <h1 className="text-2xl font-bold text-red-600 mb-4">{i18nStore.t("authError")}</h1>
            <p className="text-muted-foreground mb-4">{authStore.error}</p>
            <button
              type="button"
              onClick={() => authStore.login()}
              className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
            >
              {i18nStore.t("tryAgain")}
            </button>
          </>
        )}
      </div>
    </div>
  )
})
